import { render } from "./Lgfifteen_seven.vue?vue&type=template&id=3e2aa31e&scoped=true"
import script from "./Lgfifteen_seven.vue?vue&type=script&lang=js"
export * from "./Lgfifteen_seven.vue?vue&type=script&lang=js"

import "./Lgfifteen_seven.vue?vue&type=style&index=0&id=3e2aa31e&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2aa31e"]])

export default __exports__